// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"SubjectContainer_mainWrapper__qOScF","contentContainer":"SubjectContainer_contentContainer__u3ujh","syllabusButton":"SubjectContainer_syllabusButton__pKuk8"};